<template>
  <div class="Crop">

    <slot />

  </div>
</template>

<script>
export default {
  name: 'Crop'
}
</script>

<style>
.Crop {
  position: relative;
  /* border: 2px solid purple; */

  /* Crop element should scale to fit its parent */
  width: 100%;
  height: 100%;
}

.Crop > * {
  width: 100%;
  height: 100%;
  padding-top: 0 !important;
/* border: 5px solid blue; */
}
</style>



// WEBPACK FOOTER //
// Crop.vue?68cc824b